module.exports = __webpack_public_path__ + "img/ic_recognition_given.24ffd175.png";